import { render, staticRenderFns } from "./SideBarBlock.vue?vue&type=template&id=025cd0c0&scoped=true"
import script from "./SideBarBlock.vue?vue&type=script&lang=js"
export * from "./SideBarBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cd0c0",
  null
  
)

export default component.exports